module.exports = __webpack_public_path__ + "img/grid-srp-preview-mitsu.0819908c.png";